import Flickity from 'flickity';
import Layout from './Layout';
import ProductGridItem from './ProductGridItem';
export default class FeaturedCollection {
    constructor({ el, sectionId }) {
        this.el = el;
        this.contentWrapperEl = el.querySelector('[data-content-wrapper]');
        this.contentEl = el.querySelector('[data-content]');
        /*
         * We keep reference to the original layout of the collection
         * because dependent upon viewport width, we may need to enforce
         * one layout over the other.
         */
        this.initialLayout = this.contentEl.dataset.layout; // Product items
        this.productItems = [];
        const productItemsEls = this.el.querySelectorAll('[data-product-item]');
        for (let i = 0; i < productItemsEls.length; i++) {
            this.productItems.push(new ProductGridItem({
                el: productItemsEls[i],
                id: sectionId,
                lazy: false,
            }));
        }
        if (this.initialLayout === 'slideshow') {
            window.requestAnimationFrame(() => this._initializeFlickity());
        }
        else {
            this.onBreakpointChange = () => {
                const useSlideshow = Layout.isLessThanBreakpoint('XL');
                if (useSlideshow) {
                    this._initializeFlickity();
                }
                else {
                    this._destroyFlickity();
                }
            };
            Layout.onBreakpointChange(this.onBreakpointChange);
            if (Layout.isLessThanBreakpoint('XL')) {
                window.requestAnimationFrame(() => this._initializeFlickity());
            }
        }
    }
    unload() {
        this.productItems.forEach((productItem) => productItem.unload());
        Layout.offBreakpointChange(this.onBreakpointChange);
        this._destroyFlickity();
    }
    _initializeFlickity() {
        if (this.flickity)
            return; // Already initialized
        this.contentEl.dataset.layout = 'slideshow';
        this.flickity = new Flickity(this.contentEl, {
            autoPlay: 0,
            accessibility: true,
            cellAlign: 'left',
            cellSelector: '.productgrid--item',
            groupCells: true,
            pageDots: false,
            contain: true,
            arrowShape: 'M65.29 11.99L27.28 50L65.3 87.99L70.25 83.06L37.19 50L70.26 16.94L65.29 11.99Z',
        });
        const { resize } = Flickity.prototype;
        const viewport = this.contentEl.querySelector('.flickity-viewport');
        const slider = this.contentEl.querySelector('.flickity-slider');
        /*
         * We must wrap Flickity's slider element to allow the usage of
         * clip, and clip-path to obscure the overflow product items.
         * To use clip, and clip-path, the clipped element must be absolutely
         * positioned. In this case, the only native Flickity element
         * that is absolutely positioned is the slider; but, it moves with the first
         * slide rather than remaining in the viewport removing it as a candidate.
         * Therefore, it is necessary to include a wrapper element that we can
         * absolutely position that remains within the viewport.
         * The only thing we need to watch out for is that the elements
         * are moved in a non-destructive manner.
         */
        const sliderWrapper = document.createElement('div');
        sliderWrapper.classList.add('flickity-slider--wrapper');
        viewport.appendChild(sliderWrapper);
        sliderWrapper.appendChild(slider);
        this.flickity.resize = function r() {
            viewport.style.height = '';
            resize.call(this);
        };
    }
    _destroyFlickity() {
        if (!this.flickity)
            return; // Already uninitialized
        this.contentEl.dataset.layout = this.initialLayout;
        const viewport = this.contentEl.querySelector('.flickity-viewport');
        const slider = this.contentEl.querySelector('.flickity-slider');
        /*
         * Remember to move the Flickity native elements back
         * into the correct DOM layout, before removing the added
         * wrapper.
         */
        const sliderWrapper = this.contentEl.querySelector('.flickity-slider--wrapper');
        viewport.appendChild(slider);
        viewport.removeChild(sliderWrapper);
        this.flickity.destroy();
        this.flickity = null;
    }
}
